import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage } from '../../../utils/Errors'
import { INotification } from '../../../types/notifications'
import { getUrlWithVersion } from '../../../api/api'

export const fetchNotifications = createAsyncThunk<
    { hasMore: boolean; notifications: INotification[] } | void,
    { productIds?: string[] },
    ThunkConfig<string>
>('notificationsSlice/fetchNotifications', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    const productIds = args.productIds

    try {
        const { data } = await api.get<{
            notifications: INotification[]
            has_more: boolean
        }>(getUrlWithVersion(`/notifications`), {
            params: {
                product_ids: productIds,
            },
            paramsSerializer: {
                indexes: null,
            },
        })

        if (
            typeof data?.has_more !== 'boolean' ||
            !Array.isArray(data?.notifications)
        ) {
            const error = new Error('Received notifications in wrong format')
            console.error(error.message)
            return
        }

        return { hasMore: data.has_more, notifications: data.notifications }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to fetch notifications')
    }
})
